import type { CandidateDiscoverySource } from '@seek/data-tracking-event-catalogue';
import { useSearchParams } from 'react-router';
import { validate as validateUuid } from 'uuid';

export const useExtractTrackingFromUrl = (): string | undefined => {
  const [searchParams] = useSearchParams();
  const tracking = searchParams.get('tracking');

  const decodedTracking = tracking ? decodeURIComponent(tracking) : undefined;

  return decodedTracking;
};

export const useExtractServiceTokenFromUrl = (): string | undefined => {
  const [searchParams] = useSearchParams();
  const serviceToken = searchParams.get('serviceToken');

  if (!serviceToken) {
    return undefined;
  }

  const decodedServiceToken = decodeURIComponent(serviceToken);

  if (!validateUuid(decodedServiceToken)) {
    return undefined;
  }

  return decodedServiceToken;
};

export const useGetCandidateDiscoverySource = (
  isLoggedInUserOwnProfile: boolean,
): CandidateDiscoverySource => {
  const tracking = useExtractTrackingFromUrl();

  // logged in user own profile takes precedence over tracking origin site
  if (isLoggedInUserOwnProfile) {
    return 'OWN_PROFILE';
  }

  if (tracking === 'PROFILE_SEARCH') {
    return 'NAME_SEARCH';
  }

  return 'DIRECT_URL';
};
